import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Radio,
  message,
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  Steps,
  InputNumber,
  Divider,
  Checkbox,
  Modal,
  Result,
  Typography,
} from "antd";
import FormUpload from "../../components/Upload/FormUpload/FormUpload";
import moment from "moment";
import {
  RightOutlined,
  LeftOutlined,
  CheckOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { postRegisterLead } from "apis/lead";
import { getAgentContact } from "apis/user";
import { useParams } from "react-router-dom";
import { useFetchConstant } from "apis/constant";
import { ScreenSize } from "utils/constants";
import Locale from "react-intl-universal";

const { Paragraph, Text } = Typography;
const LeadForm = () => {
  const { id: userId } = useParams();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();

  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [invalidLink, setInvalidLink] = useState(false);
  const [agentInfo, setAgentInfo] = useState({
    name: {
      firstName: "",
      lastName: "",
    },
    email: "",
    contact: {
      countryCode: "",
      contactNumber: "",
    },
  });
  const {
    isLoading: isPropertyPurchaseLoading,
    data: propertyPurchasePurpose,
  } = useFetchConstant("propertyPurchasePurpose");
  const {
    isLoading: isMarinatalStatusLoading,
    data: marinatalStatus,
  } = useFetchConstant("marinatalStatus");

  var screenReady =
    isPropertyPurchaseLoading === false && isMarinatalStatusLoading === false
      ? true
      : false;

  console.log("marinatalStatus", marinatalStatus);

  useEffect(() => {
    // iniForm();
    getAgentInfo();
    setTimeout(() => {
      window.scrollTo(0, 0);
      console.log(window.innerWidth, 78);
    }, 500);
  }, []);

  // const iniForm = () => {
  // form2.setFields([
  //   {
  //     name: "property",
  //     value: [
  //       {
  //         mortgage_loan_amount: 0,
  //         mortgage_monthly_installment: 0
  //       }
  //     ]
  //   }
  // ]);
  // };

  const getAgentInfo = () => {
    getAgentContact(userId)
      .then((x) => {
        console.log(x);
        setAgentInfo(x);
      })
      .catch((err) => {
        setInvalidLink(true);
      });
  };

  const handleSubmitForm = async () => {
    switch (index) {
      case 0:
        const values1 = await form1.validateFields();
        setPayload({
          ...values1,
        });
        setIndex(1);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return;

      case 1:
        const values2 = await form2.validateFields();
        setPayload({
          ...payload,
          ...values2,
        });
        setIndex(2);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return;

      default:
        break;
    }

    const values3 = await form3.validateFields();
    var buffer = {
      ...payload,
      ...values3,
    };
    buffer.dob = buffer.dob.format("YYYY-MM-DD");

    setLoading(true);

    message.loading(Locale.get("addNewAdvisee.leadForm.submitYourRequest"));
    await postRegisterLead(userId, buffer)
      .then((res) => {
        console.log(res, 66);
        setLoading(false);
        message.destroy();
        message.success(Locale.get("addNewAdvisee.leadForm.registerSuccess"));
        setShowSuccess(true);
      })
      .then((err) => {
        console.log(err);
      });
  };

  const StepList = (
    <Steps current={index} style={{ width: "100%" }}>
      <Steps.Step title={window.innerWidth <= ScreenSize.md ? "Step 1" : ""} />
      <Steps.Step title={window.innerWidth <= ScreenSize.md ? "Step 2" : ""} />
      <Steps.Step title={window.innerWidth <= ScreenSize.md ? "Step 3" : ""} />
    </Steps>
  );

  const UserInfoForm = (
    <Form layout="vertical" form={form1}>
      <Form.Item label="Name / 姓名" labelCol={{ span: 24 }}>
        <Input.Group compact>
          <Form.Item
            name={["name", "firstName"]}
            noStyle
            rules={[
              {
                required: true,
                message: Locale.get(
                  "addNewAdvisee.leadForm.firstNameIsRequired"
                ),
              },
            ]}
          >
            <Input
              style={{ width: "50%" }}
              placeholder={Locale.get("addNewAdvisee.leadForm.firstName")}
            />
          </Form.Item>
          <Form.Item
            name={["name", "lastName"]}
            noStyle
            rules={[
              {
                required: true,
                message: Locale.get(
                  "addNewAdvisee.leadForm.lastNameIsRequired"
                ),
              },
            ]}
          >
            <Input
              style={{ width: "50%" }}
              placeholder={Locale.get("addNewAdvisee.leadForm.lastName")}
            />
          </Form.Item>
        </Input.Group>
      </Form.Item>

      {/* <Form.Item
        name="nric"
        label="NRIC / Passport No."
        rules={[
          {
            required: false,
            message: "NRIC is required",
          },
        ]}
      >
        <InputNumber
          placeholder="901103081234 (Optional)"
          style={{ width: "100%" }}
        />
      </Form.Item> */}

      <Form.Item
        name="dob"
        label="Date of Birth / 生日"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        rules={[
          {
            required: true,
            message: Locale.get("addNewAdvisee.leadForm.dobIsRequired"),
          },
        ]}
      >
        <DatePicker
          style={{ width: "100%" }}
          placeholder={Locale.get("addNewAdvisee.leadForm.dob")}
          disabledDate={(e) => e && e > moment()}
        />
      </Form.Item>

      <Form.Item
        name="gender"
        label="Gender / 性别"
        rules={[
          {
            required: true,
            message: Locale.get("addNewAdvisee.leadForm.genderIsRequired"),
          },
        ]}
      >
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="Male">Male / 男</Radio.Button>
          <Radio.Button value="Female">Female / 女</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item label="Contact / 联络号码" labelCol={{ span: 24 }} required>
        <Input.Group compact>
          <Form.Item
            name={["contact", "countryCode"]}
            noStyle
            rules={[{ required: true, message: "Country is required" }]}
            initialValue="60"
          >
            <Select placeholder="Select country code" style={{ width: "20%" }}>
              <Select.Option value="60">+60</Select.Option>
              <Select.Option value="65">+65</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name={["contact", "contactNumber"]}
            noStyle
            rules={[
              {
                required: true,
                message: Locale.get("addNewAdvisee.leadForm.phoneNoIsRequired"),
              },
            ]}
          >
            <Input
              style={{ width: "80%" }}
              placeholder={Locale.get("addNewAdvisee.leadForm.phoneNo")}
            />
          </Form.Item>
        </Input.Group>
      </Form.Item>

      <Form.Item
        name="email"
        label="Email / 电邮"
        rules={[
          {
            required: true,
            message: Locale.get("addNewAdvisee.leadForm.emailIsRequired"),
          },
          {
            type: "email",
            message: Locale.get("addNewAdvisee.leadForm.emailInvalid"),
          },
        ]}
      >
        <Input placeholder="example@email.com" />
      </Form.Item>

      <Form.Item
        name="occupation"
        label="Occupation / 职业"
        // rules={[
        //   {
        //     required: false,
        //     message: "Occupation is required",
        //   },
        // ]}
      >
        <Input
          placeholder={Locale.get("addNewAdvisee.leadForm.occupationOptional")}
        />
      </Form.Item>

      <Form.Item
        name="marital_status"
        label="Marital Status / 婚姻状况"
        rules={[
          {
            required: true,
            message: Locale.get(
              "addNewAdvisee.leadForm.maritalStatusIsRequired"
            ),
          },
        ]}
      >
        <Select
          placeholder={Locale.get("addNewAdvisee.leadForm.maritalStatus")}
        >
          {isMarinatalStatusLoading === false &&
            marinatalStatus.map((x) => (
              <Select.Option value={x.code}>{x.label}</Select.Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item shouldUpdate>
        {(e) => {
          const marital_status = e.getFieldValue("marital_status");

          return (
            <Form.Item
              name="marital_status_other"
              label="Marital Status Other / 其他婚姻状况"
              rules={[
                {
                  required: marital_status !== "Other" ? false : true,
                  message: Locale.get(
                    "addNewAdvisee.leadForm.maritalStatusOtherIsRequired"
                  ),
                },
              ]}
              hidden={marital_status !== "Other"}
            >
              <Input
                placeholder={Locale.get(
                  "addNewAdvisee.leadForm.maritalStatusOther"
                )}
              />
            </Form.Item>
          );
        }}
      </Form.Item>
    </Form>
  );

  const PropertyInfo = (
    <Form layout="vertical" form={form2}>
      <Form.Item
        label="Do you have property / 您有房产吗？"
        name="hasProperty"
        initialValue="No"
      >
        <Radio.Group
          buttonStyle="solid"
          style={{ width: "100%" }}
          onChange={(value) => {
            console.log(value.target.value);
            switch (value.target.value) {
              case "Yes":
                form2.setFields([
                  {
                    name: "property",
                    value: [
                      {
                        mortgage_loan_amount: 0,
                        mortgage_monthly_installment: 0,
                      },
                    ],
                  },
                ]);
                break;

              case "No":
                form2.setFields([
                  {
                    name: "property",
                    value: [],
                  },
                ]);
                break;

              default:
                break;
            }
          }}
        >
          <Radio.Button
            value="Yes"
            style={{ width: "50%", textAlign: "center" }}
          >
            Yes / 有房产
          </Radio.Button>
          <Radio.Button
            value="No"
            style={{ width: "50%", textAlign: "center" }}
          >
            No / 无房产
          </Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.List name="property">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }, index) => (
              <>
                <Divider>
                  Property {index + 1} / 房产 {index + 1}
                </Divider>

                <Form.Item
                  label="Mortgage Amount Balance / 房贷数额"
                  name={[name, "mortgage_loan_amount"]}
                  rules={[
                    {
                      required: true,
                      message: Locale.get(
                        "addNewAdvisee.leadForm.mortgageAmountBalanceIsRequired"
                      ),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Mortgage Amount Balance 房贷数额"
                    style={{ width: "100%" }}
                    min={0}
                    precision={2}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value.replace(/(,*)/g, "")}
                  />
                </Form.Item>
                <Form.Item
                  label="Mortgage Installment / 每月供期"
                  name={[name, "mortgage_monthly_installment"]}
                  rules={[
                    {
                      required: true,
                      message: Locale.get(
                        "addNewAdvisee.leadForm.mortgageInstallmentIsRequired"
                      ),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Mortgage Installment / 每月供期"
                    style={{ width: "100%" }}
                    min={0}
                    precision={2}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value.replace(/(,*)/g, "")}
                  />
                </Form.Item>

                <Form.Item
                  name={[name, "is_insured"]}
                  label="Do you have MRTA to cover this property? 你有购买 MRTA 给这一个房产吗"
                  rules={[
                    {
                      required: true,
                      message: Locale.get(
                        "addNewAdvisee.leadForm.selectMrtaStatus"
                      ),
                    },
                  ]}
                >
                  <Radio.Group style={{ width: "100%" }}>
                    <Radio value="Yes" style={{ width: "100%" }}>
                      Yes / 有
                    </Radio>
                    <Radio value="No" style={{ width: "100%" }}>
                      No / 没有
                    </Radio>
                    <Radio value="Not Sure" style={{ width: "100%" }}>
                      Not Sure / 不确定
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  name={[name, "purchase_purpose"]}
                  label="What is the purpose of this property? 这个房产的用途"
                  rules={[
                    {
                      required: true,
                      message: Locale.get(
                        "addNewAdvisee.leadForm.selectPurchasePurpose"
                      ),
                    },
                  ]}
                >
                  <Radio.Group style={{ width: "100%" }}>
                    {propertyPurchasePurpose.map((x) => (
                      <Radio
                        value={x.code}
                        style={{ width: "100%" }}
                        key={x.code}
                      >
                        {x.label}
                      </Radio>
                    ))}
                    {/* <Radio value="Own Use" style={{ width: "100%" }}>
                      Own Use / 自住
                    </Radio>
                    <Radio value="Investment" style={{ width: "100%" }}>
                      Investment / 投资
                    </Radio>
                    <Radio
                      value="Not certain at this moment"
                      style={{ width: "100%" }}
                    >
                      Not certain at this moment / 暂时不确定
                    </Radio> */}
                  </Radio.Group>
                </Form.Item>

                {index !== 0 && (
                  <Button
                    block
                    type="dashed"
                    onClick={() => remove(name)}
                    icon={<MinusCircleOutlined />}
                    style={{
                      marginBottom: 16,
                      border: "1px dashed red",
                      color: "red",
                    }}
                  >
                    Remove Property {index + 1} / 删除房产 {index + 1}
                  </Button>
                )}
              </>
            ))}

            <Form.Item shouldUpdate>
              {(e) => {
                const hasProperty = e.getFieldValue("hasProperty");
                if (!hasProperty || hasProperty === "No") {
                  return;
                }
                return (
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Property / 添加房产
                  </Button>
                );
              }}
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );

  const ExpensesInfo = (
    <Form layout="vertical" form={form3}>
      <Form.Item
        name="personal_expenses"
        label="How much is your monthly expenses, to support your families and/or your responsibilities, excluding insurance and mortgage? 你每个月需要照顾家庭的花费总额是多少（不包括保险费和房贷供期）？"
        rules={[
          {
            required: true,
            message: Locale.get("addNewAdvisee.leadForm.expensesIsRequired"),
          },
        ]}
      >
        <InputNumber
          style={{ width: "100%" }}
          disabled={loading}
          min={0}
          precision={2}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value.replace(/(,*)/g, "")}
        />
      </Form.Item>
      {/* <Form.Item
        name="personal_commitment"
        label="How much is your total car loans & monthly payments? 你的汽车贷款和每月还款总额是多少？（RM)"
        rules={[
          {
            required: true,
            message: "Expenses is required"
          }
        ]}
      >
        <InputNumber style={{ width: "100%" }} disabled={loading} />
      </Form.Item> */}

      <Divider>Family Responsibilities 家庭责任</Divider>

      <Form.Item
        name="have_children"
        label="Do you have children? 你有孩子吗？"
        rules={[
          {
            required: true,
            message: Locale.get(
              "addNewAdvisee.leadForm.doYouHaveChildrenIsRequired"
            ),
          },
        ]}
      >
        <Radio.Group style={{ width: "100%" }} disabled={loading}>
          <Radio value="Yes" style={{ width: "100%" }}>
            Yes / 有
          </Radio>
          <Radio value="No" style={{ width: "100%" }}>
            No / 没有
          </Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(e, v) => e.have_children !== v.have_children}
      >
        {(e) => {
          const have_children = e.getFieldValue("have_children");
          return (
            <>
              <Form.Item
                hidden={have_children !== "Yes"}
                name="no_of_children"
                label="Number of Children / 有几个孩子?"
                rules={[
                  {
                    required: have_children === "Yes",
                    message: Locale.get(
                      "addNewAdvisee.leadForm.numberOfChildrenIsRequired"
                    ),
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} disabled={loading} />
              </Form.Item>

              <Form.Item
                hidden={have_children !== "Yes"}
                name="children_age"
                label="Age of Youngest Child / 请列出最年幼孩子的岁数"
                rules={[
                  {
                    required: have_children === "Yes",
                    message: Locale.get(
                      "addNewAdvisee.leadForm.ageOfYoungestChildIsRequired"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  disabled={loading}
                  min={0}
                  precision={0}
                />
              </Form.Item>

              <Form.Item
                hidden={have_children !== "Yes"}
                name="children_age_extra"
                label="In your opinion, how many more years do you need take care of your children before they become fully independent? 你觉得你还要照顾孩子多少年直到他们全部可以独立？ （E.g. 18 years / 18年）"
                rules={[
                  {
                    required: have_children === "Yes",
                    message: Locale.get(
                      "addNewAdvisee.leadForm.yearsIsRequired"
                    ),
                  },
                ]}
              >
                <Input style={{ width: "100%" }} disabled={loading} />
              </Form.Item>
            </>
          );
        }}
      </Form.Item>

      <Form.Item
        name="family_member_to_take_care"
        label="Do you have family members that need you to take care (like parents, or siblings)? 你是否有需要你照顾的家庭成员例如父母或兄弟姐妹？"
        rules={[
          {
            required: true,
            message: Locale.get(
              "addNewAdvisee.leadForm.familyTakeCareIsRequired"
            ),
          },
        ]}
      >
        <Radio.Group style={{ width: "100%" }} disabled={loading}>
          <Radio value="Yes" style={{ width: "100%" }}>
            Yes / 有
          </Radio>
          <Radio value="No" style={{ width: "100%" }}>
            No / 没有
          </Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(e, v) =>
          e.family_member_to_take_care !== v.family_member_to_take_care
        }
      >
        {(e) => {
          const family_member_to_take_care = e.getFieldValue(
            "family_member_to_take_care"
          );
          return (
            <Form.Item
              hidden={family_member_to_take_care !== "Yes"}
              name="legafamily_member_to_take_care_extra"
              label="Please estimate how many more years that you need to care for them? 如果你需要照顾家庭成员，请预算你需要照顾他们多少年？ （E.g. 15 years / 15年）"
              rules={[
                {
                  required: family_member_to_take_care === "Yes",
                  message: Locale.get(
                    "addNewAdvisee.leadForm.estimatedYearsIsRequired"
                  ),
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} disabled={loading} />
            </Form.Item>
          );
        }}
      </Form.Item>

      <Divider>Insurance Policy /  保单</Divider>

      <Form.Item
        name="insurance_policy"
        label="How many insurance policies do you have? 你一共有多少份保单?"
        // rules={[
        //   {
        //     required: false,
        //     message: "Expenses is required",
        //   },
        // ]}
        initialValue={0}
      >
        <InputNumber
          style={{ width: "100%" }}
          disabled={loading}
          precision={0}
          min={0}
        />
      </Form.Item>

      <FormUpload
        label="Attach insurance policy / 保险单附件"
        name={"insurance_attachment"}
        acceptTypes={["image/*"]}
        isDisplayCard
        labelButtonUpload={Locale.get("addNewAdvisee.leadForm.upload")}
        // labelButtonUpload="Upload"
        fileSizeLimitInMb={10}
        isMultiple
        isDisabled={loading}
        //  tooltipMessage="Use square size logo. Best size: 128px * 128px"
      />

      <Form.Item
        name="privacy_policy"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value
                ? Promise.resolve()
                : Promise.reject(
                    Locale.get("addNewAdvisee.leadForm.privacyPolicyIsRequired")
                  ),
          },
        ]}
        initialValue={false}
      >
        <Checkbox disabled={loading}>
          {Locale.get("addNewAdvisee.leadForm.iAgreeToTheFinport")}{" "}
          <a href="https://finport.com.my/privacy-policy" target="_blank">
            <strong>
              {Locale.get("addNewAdvisee.leadForm.privacyPolicy")}
            </strong>
          </a>
        </Checkbox>
      </Form.Item>
    </Form>
  );

  const submitSuccessComponent = (
    <Row>
      <Col span={24}>
        <Result
          status="success"
          title={
            <Row justify="center">
              <Col>
                {Locale.get("addNewAdvisee.leadForm.successfullySubmit")}
              </Col>
            </Row>
          }
          subTitle={
            <Row justify="center">
              <Col>
                {Locale.get("addNewAdvisee.leadForm.forMoreInformation")}
              </Col>
              <Row
                style={{
                  width: "100%",
                  color: "#000",
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                <Col span={24}>
                  {agentInfo.name?.firstName} {agentInfo.name?.lastName}
                </Col>
              </Row>
              <Row
                style={{
                  width: "100%",
                  color: "#000",
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                <Col span={24}>
                  {agentInfo.contact?.countryCode}{" "}
                  {agentInfo.contact?.contactNumber}
                </Col>
              </Row>
              <Row
                style={{
                  width: "100%",
                  color: "#000",
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                <Col span={24}>{agentInfo.email}</Col>
              </Row>
            </Row>
          }
          extra={[
            <Button
              key="buy"
              type="primary"
              onClick={() => window.location.reload()}
            >
              {Locale.get("addNewAdvisee.leadForm.submitAgain")}
            </Button>,
          ]}
        />
      </Col>
    </Row>
  );

  const InvalidLinkComponent = (
    <Row justify="center">
      <Col
        xs={22}
        md={18}
        lg={8}
        style={{
          backgroundColor: "#fff",
          padding: 32,
          borderRadius: 8,
        }}
      >
        <Result
          status="error"
          title="Invalid URL"
          subTitle="Given url in not a valid link, please request new link from user."
        >
          <div className="desc">
            <Paragraph>
              <Text
                strong
                style={{
                  fontSize: 16,
                }}
              >
                The content you request has the following error:
              </Text>
            </Paragraph>
            <Paragraph>
              <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
              Invalid link.
            </Paragraph>
            <Paragraph>
              <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
              Link copy error.
            </Paragraph>
          </div>
        </Result>
      </Col>
    </Row>
  );
  const Footer =
    index === 0 ? (
      <Button
        type="primary"
        style={{ width: "100%" }}
        onClick={handleSubmitForm}
      >
        Next / 下一步 <RightOutlined />
      </Button>
    ) : index === 2 ? (
      <Row justify="space-between">
        <Col span={11}>
          <Button
            disabled={loading}
            style={{ width: "100%" }}
            onClick={() => setIndex(index - 1)}
          >
            <LeftOutlined /> Back / 返回
          </Button>
        </Col>
        <Col span={11}>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={handleSubmitForm}
            loading={loading}
          >
            Submit / 提交 <CheckOutlined />
          </Button>
        </Col>
      </Row>
    ) : (
      <Row justify="space-between">
        <Col span={11}>
          <Button style={{ width: "100%" }} onClick={() => setIndex(index - 1)}>
            <LeftOutlined /> Back / 返回
          </Button>
        </Col>
        <Col span={11}>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={handleSubmitForm}
          >
            Next / 下一步 <RightOutlined />
          </Button>
        </Col>
      </Row>
    );

  return (
    <div style={{ width: "100%", paddingTop: 32, paddingBottom: 32 }}>
      {invalidLink ? (
        InvalidLinkComponent
      ) : (
        <Row justify="center">
          <Col
            xs={22}
            md={22}
            lg={8}
            style={{
              backgroundColor: "#fff",
              padding: 32,
              borderRadius: 8,
            }}
          >
            <Row style={{ marginBottom: 16 }} justify="center">
              <Col
                style={{
                  fontSize: 32,
                  fontWeight: 600,
                  color: "#000",
                  textAlign: "center",
                }}
              >
                {Locale.get(
                  "addNewAdvisee.leadForm.financeAnalysisReportBasicInformation"
                )}
              </Col>
            </Row>

            {showSuccess === false && (
              <Row style={{ marginBottom: 32 }}>
                <Col span={24}>{StepList}</Col>
              </Row>
            )}

            {index === 0 &&
              showSuccess === false &&
              screenReady === true &&
              UserInfoForm}
            {index === 1 &&
              showSuccess === false &&
              screenReady === true &&
              PropertyInfo}
            {index === 2 && showSuccess === false && ExpensesInfo}

            {showSuccess && submitSuccessComponent}
            {showSuccess === false && Footer}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LeadForm;
